const locales = [
  {
    locale: 'en',
    messages: import('./en'),
    //loadData: import(`@formatjs/intl-relativetimeformat/dist/locale-data/en`),
  },
  {
    locale: 'zh-tw',
    messages: import('./zh-tw'),
    //loadData: import(`@formatjs/intl-relativetimeformat/dist/locale-data/de`),
  },
];

export default locales;
